export default __webpack_public_path__ + "static/media/page-about-img1.49cdd883.jpg";